import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("ellipse", {
  cx: 35,
  cy: 43,
  rx: 35,
  ry: 3,
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M69.5 0L6 43c9.667 0 30-1 39-7 7.326-4.884 6.5-11.5 5.5-15.5l22-16-3-4.5z",
  fill: "#73C4FF"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 73,
    height: 46,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/faq-surgery.ca4fcaee.svg";
export { SvgComponent as ReactComponent };